/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createGetOrganizationProfileResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ErrorResponse, type GetOrganizationProfileResponse, type InternalErrorResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organization/profile
 */
export interface ProfileRequestBuilder extends BaseRequestBuilder<ProfileRequestBuilder> {
    /**
     * Returns non-sensitive organization details (identity, name, contact info, billing address), the order types it offers and the names of its payment terms, in display order, for the caller's organization. Safe for Customer and SalesRep tokens and for storefront keys; excludes subscriptions, entitlements, price tiers and account setup. The organization is resolved from the token.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<GetOrganizationProfileResponse>}
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<ProfileRequestBuilderGetQueryParameters> | undefined) : Promise<GetOrganizationProfileResponse | undefined>;
    /**
     * Returns non-sensitive organization details (identity, name, contact info, billing address), the order types it offers and the names of its payment terms, in display order, for the caller's organization. Safe for Customer and SalesRep tokens and for storefront keys; excludes subscriptions, entitlements, price tiers and account setup. The organization is resolved from the token.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ProfileRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Returns non-sensitive organization details (identity, name, contact info, billing address), the order types it offers and the names of its payment terms, in display order, for the caller's organization. Safe for Customer and SalesRep tokens and for storefront keys; excludes subscriptions, entitlements, price tiers and account setup. The organization is resolved from the token.
 */
export interface ProfileRequestBuilderGetQueryParameters {
    /**
     * Optional: OrganizationId to switch to (must be in the user's OrgCodes).
     */
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const ProfileRequestBuilderUriTemplate = "{+baseurl}/api/organization/profile{?useOrganizationId*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const ProfileRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ProfileRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createGetOrganizationProfileResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
